import React, { useRef, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { addDeliveryOrder, removeDeliveryOrder, addSizes, showSizes } from '../../store/actions/index'
import { Dropdown, Form, Button, FormControl, Row, Col, ListGroup, OverlayTrigger, FormCheck } from 'react-bootstrap'
import { CustomMenu, CustomToggle } from '../presentational-components/simple-objects/CustomDropDown'
import DeliveryOrderList from './DeliveryOrderList'
import '../../index.css'
import SizesControl from './SizesControl'
import { sizeValues } from './SizesControl'
import { FetchTransactionInfos, FetchArticleTypeImages, FetchBoutiques, FetchDesigners, FetchBoutiqueInfosArticleTypesForDelivery, FetchSelectedStocksReport } from '../../fetcher'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import AlertMessage from '../presentational-components/AlertMessage'
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'
import { RenderImage } from '../presentational-components/ImageViewer'
import { SimpleDateSelect } from '../presentational-components/FilterComponents'
import moment from 'moment'


let numberInputs = []
let sizeCategory
let articleEntry
let articleSysId
let articleIdFaex
let articleNumberDesigner
let salePrice
let designerName
let image
let articleSizes
let articleDropdown
let boutiqueDropdown
let isWholeStockAllowed

//focusFirstItemOnShow='keyboard' onClick={setFocusOnFilter}

const DeliveryOrderContainer = ({ dispatch, handleCloseMask, reloadParent, draft = null, template = null, backDelivery = false }) => {
    const [articles, setArticles] = useState([])
    const [sizeCats, setSizeCats] = useState([])
    const articleHeaderDefault = "Artikeltyp auswählen"
    const articleHeaderDuringLoading = "Artikeltypen werden geladen"
    const [articleNameHeader, setArticleHeader] = useState(articleHeaderDefault)
    const [boutiqueNameHeader, setBoutiqueHeader] = useState("Boutique auswählen")
    const [designerNameHeader, setDesignerHeader] = useState("Designer auswählen")
    const [uiError, setError] = useState(false)

    const [deliveryOrder, setDeliveryOrder] = useState([])
    const [deliveryOrderAvailability, setDeliveryOrderAvailability] = useState([])

    const [remark, setRemark] = useState("")
    const [transactionDate, setTransactionDate] = useState(draft !== null ? draft.TransactionDate : moment(Date.now()).format("DD.MM.YYYY"))
    const [transactionNumber, setTransactionNumber] = useState(draft !== null ? draft.TransactionNumber : "")

    const [isDraftUpdate, setIsDraftUpdate] = useState(false)

    const [isFaexStorage, setIsFaexStorage] = useState(false)
    const [boutiques, setBoutiques] = useState([])
    const [boutiqueSelection, setBoutiqueSelection] = useState("")

    const [articleDropDownShow, setArticleDropDownShow] = useState(false)

    const [designers, setDesigners] = useState([])
    const [designerSelection, setDesignerSelection] = useState("")
    const [designerSysId, setDesignerSysId] = useState("")
    const [designerStorageSysId, setDesignerStorageSysId] = useState("")
    const [articleTypesList, setArticleTypesList] = useState([])
    const [isWholeStockAllowed, setIsWholeStockAllowed] = useState(false)

    //const setArticleTypesListAdapter = (articleTypeList) => {
    //    articleTypeList.forEach(articleType => articleType["SalePrice"] = articleType.PriceUnit)
    //    console.log("setArticleTypesListAdapter")
    //    console.log(articleTypeList)
    //    isWholeStockAllowed = true
    //    setArticles(prev => prev = articleTypeList)
    //}

    const [showAlertMessage, setShowAlert] = useState(false)

    const [taskName, setTaskName] = useState("DeliveryOrderContainer unbekannte Task")

    const controller = new AbortController()
    const signal = controller.signal

    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [articleDataReady, setArticleDataToReady] = useState(false)

    const addingImages = (articleTypeImages) => {
        let copiedArticleData = [...articles]
        articleTypeImages.forEach(image => copiedArticleData.find(x => x.ArticleTypeSysId == image.ArticleTypeSysId)["Image"] = 'data:image/png;base64,' + image.Data)
        setArticles(copiedArticleData)
    }

    const setArticleDropDownShow2 = (articleDropDownShow) => {
        console.log(articleDropDownShow)

        if (isWholeStockAllowed === true) {
            setArticleDropDownShow(prev => prev = articleDropDownShow)
        }
        console.log("setArticleDropDownShow2", articleDropDownShow, isWholeStockAllowed)
    }

    const setArticlesExtended = (articles) => {
        setArticleHeader(prev => prev = articleHeaderDefault)
        setArticles(prev => prev = articles)
    }

    const fetchTheAvailabilityForDraftOrTemplate = (deliveryOrder) => {
        let articleSysIds = {
            SysIds: deliveryOrder.map(x => {
                let object = new Object();
                object.SysId = x.ArticleTypeSysId;
                return object;
            })
        }

        let articleSysIds1 = {
            SysIds: deliveryOrder.reduce(
                function (a, b) {
                    return a.concat(b.articleTypes.map(x => {
                        console.log("SASASASASASASA", x)
                        let object = new Object();
                        object.SysId = x.articleSysId;
                        return object;
                    })); }, [])

        }
        let articleSysIds2 = deliveryOrder.flatMap(x => x.articleTypes).map(x => x.articleSysId)


        console.log("fetchTheAvailabilityForDraftOrTemplate", deliveryOrder)
        console.log(deliveryOrder)

        console.log("articleSysIds", articleSysIds)
        console.log(articleSysIds)

        console.log("articleSysIds1", articleSysIds1)
        console.log(articleSysIds1)

        FetchSelectedStocksReport(setDeliveryOrderAvailability, articleSysIds2, openAlert, signal, "DeliveryOrderContainerUpper")
    }

    useEffect(() => {
        setIsWholeStockAllowed(prev => prev = false)
        setTaskName("Die Designer werden geladen.")
        FetchDesigners(setDesigners, openAlert, "DeliveryOrderContainer")
        console.log(taskName)
        console.log("Die Designer werden geladen.")

    }, [])

    useEffect(() => {
        if (JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX") {
            setTaskName("Die Boutiques werden geladen.")
            FetchBoutiques(setBoutiques, openAlert, "DeliveryOrderContainer")
            setIsFaexStorage(true)
        }
    }, [])

    const [fetchWholeDesignerStock, setFetchWholeDesignerStock] = useState(false)
    const handleSetFetchWholeDesignerStock = () => {
        setFetchWholeDesignerStock(!fetchWholeDesignerStock)
    }

    useEffect(() => {
        setArticleDropDownShow2(false)
        if (fetchWholeDesignerStock === true) {
            //let newDeliveryOrder = [...deliveryOrder]
            let newDeliveryOrder = []
            let designerStock = articles.filter(x => x.Sizes.reduce((a, size) => a += size.AmountInStorage, 0) > 0)

            console.log("Filling DeliveryOrderContainer with DesignerStock:")
            console.log(articles)

            console.log(designerStock)

            designerStock.forEach(article => {
                if (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat) == null)
                    newDeliveryOrder.push({ sizeCat: article.SizeCat, articleTypes: [] })
                if (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId) == null)
                    newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.push({ articleName: article.Name, articleSysId: article.ArticleTypeSysId, articleIdFaex: article.ArticleIdFaex, articleNumberDesigner: article.ArticleNumberDesigner, salePrice: article.SalePrice, designerName: designerSelection.Name, image: article.Image, sizeEntries: [] })
                article.Sizes.forEach(z =>
                (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue) == null
                    ? newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.push({ SizeValue: z.SizeValue, Amount: parseInt(z.AmountInStorage), AmountInStorage: parseInt(z.AmountInStorage) })
                    : newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue).Amount += parseInt(z.Amount)))
            })

            setDeliveryOrder(newDeliveryOrder)
        } else {
            /*if (draft === null) */setDeliveryOrder([])
        }

    }, [fetchWholeDesignerStock])


    useEffect(() => {
        console.log("Die Designers werden geladen")
        setTaskName("Die Designers werden geladen")
        FetchDesigners(setDesigners, openAlert, "DeliveryOrderContainer")
        //FetchTransactionInfos(setArticles, setSizeCats, openAlert, setArticleDataToReady, () => console.log("Fetched articles for draft or template ", articles), "DeliveryOrderContainer")

        console.log("Draft or Template", draft, template, articles)

        if (draft !== null) {
            console.log("Draft ", articles)
            console.log(draft)

            setBoutiqueSelection({ StorageSysId: draft.SourceOrTargetSysId })
            //let boutiqueFromDraft = boutiques.find(x => x.StorageSysId === draft.SourceOrTargetSysId)
            //setBoutiqueHeader(boutiqueFromDraft !== undefined ? boutiqueFromDraft.Name : "")
            setRemark(draft.Remark)
            setTransactionNumber(draft.TransactionNumber)
            setTransactionDate(draft.TransactionDate)
            setIsDraftUpdate(true)

            let newDeliveryOrder = [...deliveryOrder]

            draft.Articles.forEach(article => {
                if (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat) == null)
                    newDeliveryOrder.push({ sizeCat: article.SizeCat, articleTypes: [] })
                if (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId) == null)
                    newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.push({ articleName: article.Name, articleSysId: article.ArticleTypeSysId, articleIdFaex: article.ArticleIdFaex, articleNumberDesigner: article.ArticleNumberDesigner, salePrice: article.SalePrice, designerName: article.DesignerName, image: article.Image, sizeEntries: [] })
                article.Sizes.forEach(z =>
                (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue) == null
                    ? newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.push({ SizeValue: z.SizeValue, Amount: parseInt(z.Amount), AmountInStorage: parseInt(z.AmountInStorage) })
                    : newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue).Amount += parseInt(z.Amount)))
            }
            )
            setDeliveryOrder(newDeliveryOrder)

            setTaskName("Die Verfügbarkeit der Artikel wird geladen")
            
            fetchTheAvailabilityForDraftOrTemplate(newDeliveryOrder)
        }

        if (template != null) {
            console.log("Template")
            console.log(template)

            setRemark(template.Remark)
            setTransactionNumber(template.TransactionNumber)
            setTransactionDate(template.TransactionDate)

            let newDeliveryOrder = [...deliveryOrder]

            template.Articles.forEach(article => {
                console.log(article)
                if (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat) == null)
                    newDeliveryOrder.push({ sizeCat: article.SizeCat, articleTypes: [] })
                if (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId) == null)
                    newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.push({ articleName: article.Name, articleSysId: article.ArticleTypeSysId, articleIdFaex: article.ArticleIdFaex, articleNumberDesigner: article.ArticleNumberDesigner, salePrice: article.SalePrice, designerName: article.DesignerName, image: article.Image, sizeEntries: [] })
                article.Sizes.forEach(z =>
                (newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue) == null
                    ? newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.push({ SizeValue: z.SizeValue, Amount: parseInt(z.Amount), AmountInStorage: parseInt(z.AmountInStorage) })
                    : newDeliveryOrder.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue).Amount += parseInt(z.Amount)))
            }
            )
            setDeliveryOrder(newDeliveryOrder)
        }

    }, [])


    useEffect(() => {
        if (articleDataReady) {
            setTaskName("Die Bilder werden geladen.")
            FetchArticleTypeImages(articles.map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert, "DeliveryOrderContainer")
        }
    }, [articleDataReady])

    useEffect(() => {
        console.log("Use effects designerSelection")
        setArticleHeader(articleHeaderDefault)
        setIsWholeStockAllowed(prev => prev = false)
        if (designerSelection !== "" && designerSelection !== null && designerSelection !== undefined) {
            setArticleHeader(articleHeaderDuringLoading)
            setTaskName("Die verfügbare Artikel werden geladen")
            setArticleDataToReady(prev => prev = false)
            FetchBoutiqueInfosArticleTypesForDelivery(designerSelection.MandatorSysId, setArticlesExtended, openAlert, setArticleDataToReady, "DeliveryOrderContainer")
        //    isWholeStockAllowed = true
        }
        else
            setIsWholeStockAllowed(prev => prev = false)
    }, [designerSelection])

    useEffect(() => {
        console.log("useEffect articles", isWholeStockAllowed)
        if (articles.length > 0) {
        setIsWholeStockAllowed(prev => prev = true)
        }
        console.log("useEffect articles", isWholeStockAllowed, articles)

    }, [articles])

    useEffect(() => {
        if (deliveryOrder.length > 0) {
            setIsWholeStockAllowed(prev => prev = true)
            console.log("deliveryOrderAvailability", deliveryOrderAvailability)

            let adjustedDeliveryOrder = [...deliveryOrder]
            console.log("deliveryOrderAvailability2", adjustedDeliveryOrder
                .flatMap(t => t.articleTypes))

            adjustedDeliveryOrder
                .flatMap(t => t.articleTypes)
                .forEach(x => x.sizeEntries.forEach(
                    y => {
                        if (deliveryOrderAvailability.articleTypes.filter(
                            z => z.articleSysId == x.articleSysId) != null) {

                            let a = deliveryOrderAvailability.articleTypes.filter(
                                z => z.articleSysId == x.articleSysId)[0];

                            if (a.sizeEntries.filter(
                                h => h.sizeValue == y.SizeValue)[0] != null) {
                                y.AmountInStorage = a.sizeEntries.filter(
                                    h => h.sizeValue == y.SizeValue)[0].amount
                            }

                        }
                    }));

            console.log("deliveryOrderAvailability adjustedDeliveryOrder", adjustedDeliveryOrder)
            setDeliveryOrder(prev => prev = adjustedDeliveryOrder)
        }
    }, [deliveryOrderAvailability])

    const setArticleFocus = () => {
        articleDropdown.focus()
    }

    const handleChange = (e, article) => {
        console.log("handleChange ArticleDropDown")
        if (e !== null) e.preventDefault()
        setArticleHeader(article != null ? article.ArticleTypeName : articleHeaderDefault)
        setArticleDropDownShow2(false)

        console.log("handleChange size1", article)
        if (article != null && article != undefined) {
            sizeCategory = article.SizeCat
            articleSysId = article.ArticleTypeSysId
            articleIdFaex = article.ArticleIdFaex
            articleNumberDesigner = article.ArticleNumberDesigner
            salePrice = article.SalePrice
            image = article.Image
            designerName = article.DesignerName
            articleSizes = article.Sizes
            console.log("Article Sizes in DeliveryOrderContainer:")
            console.log(article.SizeValues)
            console.log(article)
            console.log("articleSizes")
            console.log(articleSizes)
            console.log("handleChange size1", article)
            dispatch(showSizes(article.ArticleTypeName, article.Sizes))
        } else {
            sizeCategory = ""
            console.log("handleChange size2", article)
            dispatch(showSizes("", []))
        }
    }

    const handleSetBoutiqueSelection = (boutique) => {
        setBoutiqueSelection(boutique)
        setBoutiqueHeader(boutique.Name)
    }

    const handleSetDesignerSelection = (designer) => {
        setDesignerSysId(prev => prev = designer.MandatorSysId)
        setDesignerStorageSysId(prev => prev = designer.StorageSysId)
        setDesignerSelection(prev => prev = designer)
        setDesignerHeader(prev => prev = designer.Name)
        console.log("DesignerSelection MandatorSysId")
        console.log(designer)
    }

    const setArticleTypesWithStocks = (articles) => {
        let articlesWithStock = articles.filter(x => x.Sizes.length > 0)
        articlesWithStock.forEach(article => article["SalePrice"] = article.PriceUnit)
        setArticles(prev => prev = articlesWithStock)
        setIsWholeStockAllowed(prev => prev = true)
    }

    const handleSetDesigner = (designer) => {
        console.log("handleSetDesigner")
        console.log(designer)
        setIsWholeStockAllowed(prev => prev = false)
        if (designer !== "" && designer !== null && designer !== undefined) {
            setArticleDropDownShow2(false)
            setDesignerSysId(prev => prev = designer.MandatorSysId)
            setDesignerStorageSysId(prev => prev = designer.StorageSysId)
            setDesignerSelection(prev => prev = designer)
            setDesignerHeader(prev => prev = designer.Name)
        }
    }

    const submitDeliveryOrder = (e) => {
        e.preventDefault()
        console.log("DeliveryOrder new")
        console.log(deliveryOrder)
        console.log(articles)

        if (sizeValues.some(x => parseInt(x.amount) != 0)) {

            let newDeliveryOrder = [...deliveryOrder]

            if (newDeliveryOrder.find(x => x.sizeCat == sizeCategory) == null)
                newDeliveryOrder.push({ sizeCat: sizeCategory, articleTypes: [] })
            if (newDeliveryOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId) == null)
                newDeliveryOrder.find(x => x.sizeCat == sizeCategory).articleTypes.push({ articleName: articleNameHeader, articleSysId: articleSysId, articleIdFaex: articleIdFaex, articleNumberDesigner: articleNumberDesigner, salePrice: salePrice, designerName: designerName, image: image, sizeEntries: [] })
            sizeValues.forEach(z => 
            (newDeliveryOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue) == null
                ? newDeliveryOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.push({
                    SizeValue: z.size.SizeValue, Amount: parseInt(z.amount),
                    AmountInStorage: parseInt(articleSizes.find(articleSize => articleSize.SizeValue === z.size.SizeValue).AmountInStorage)
                })
                : newDeliveryOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue).Amount += parseInt(z.amount)))

            setDeliveryOrder(newDeliveryOrder)

            handleChange(null, null)
            dispatch(showSizes("", []))
            setError(false)
        } else {
            setError(true)
        }

        setArticleFocus()
    }

    const cancelDeliveryOrder = (e) => {
        e.preventDefault()
        //console.log("CancelDeliveryOrder new")

        //setDeliveryOrder([...deliveryOrder])

        handleChange(null, null)
        dispatch(showSizes("", []))
        setError(false)

        setArticleFocus()
    }

    const renderOrderInput = () => {
        return (
            <div className="form-inline order-input">
                <SizesControl />
                <Button variant="secondary" className="form form-inline order-input order-input-button" type="submit"> ✓ </Button>
                {/*<Button variant="secondary" className="form form-inline order-input order-input-button remove-order" onClick={cancelDeliveryOrder}> &#10060; </Button>*/}
            </div>
        )
    }

    const renderErrorMessage = () => {
        return (<div className="error error-message">Mindestens ein Wert muss gesetzt sein.</div>)
    }

    const removeOrderEntry = (e, sizeCat, articleEntry) => {
        e.preventDefault()

        let removeFromDeliveryOrder = [...deliveryOrder]

        removeFromDeliveryOrder.forEach(function (sizeCat) {
            sizeCat.articleTypes = sizeCat.articleTypes.filter(x => x.articleSysId != articleEntry.articleSysId)
        })
        removeFromDeliveryOrder = removeFromDeliveryOrder.filter(x => x.articleTypes.length > 0)

        setDeliveryOrder(removeFromDeliveryOrder)
    }

    const resetOrderEntries = () => {
        setDeliveryOrder([])
    }

    const [boutiqueFilterInput, setBoutiqueFilterInput] = useState("")
    const handleBoutiqueFilter = (e) => {
        setBoutiqueFilterInput(e.target.value)
    }

    const [designerFilterInput, setDesignerFilterInput] = useState("")
    const handleDesignerFilter = (e) => {
        setDesignerFilterInput(e.target.value)
    }

    const [articleFilterInput, setArticleFilterInput] = useState("")
    const handleArticleFilter = (e) => {
        setArticleFilterInput(e.target.value)
    }

    const handleDatePickerCallback = (start) => {
        console.log("handleDatePickerCallback")
        console.log(start)
        setTransactionDate(moment(start).format("DD.MM.YYYY"));
    }

    const handleClearFilter = () => {
        setTransactionDate("")
    }

    const renderFAEXDeliveryOptions = () => {
        if (backDelivery === false) {
            return (
                <>
                    <Dropdown className="form">
                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components-boutique" >
                            {boutiqueNameHeader}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="article-dropdown">
                            <FormControl className="globalSearch-deliveryOrder" as="input" placeholder="Name Boutique..." value={boutiqueFilterInput} onChange={handleBoutiqueFilter}></FormControl>
                            {
                                boutiques.filter(x => x.Name.toLowerCase().includes(boutiqueFilterInput.toLowerCase()))
                                    .sort((a, b) => a.Name.localeCompare(b.Name))
                                    .map(boutique =>
                                        <Dropdown.Item variant="secondary" className="listGroup-item" active={false} onSelect={() => handleSetBoutiqueSelection(boutique)}>
                                            {boutique.Name}
                                        </Dropdown.Item>
                                    )
                            }

                        </Dropdown.Menu>
                    </Dropdown>

                </>
            )
        } else {
            return("")
        }
    }

    return (
        <div >
            {/*<h1>Neuer Lieferschein</h1>*/}

            {isFaexStorage ? renderFAEXDeliveryOptions() : null}

            <Form>
                <Row>
                    <Col>
                        <Form.Control className="smallInput" size="sm" placeholder="Lieferscheinnummer" onChange={(e) => setTransactionNumber(e.target.value)} value = { transactionNumber } />
                    </Col>
                    <Col>
                        {SimpleDateSelect(handleDatePickerCallback, handleClearFilter, transactionDate)}
                    </Col>
                </Row>
            </Form>

            <Form>
                <Row>
                    <Col>
                        <Dropdown className="form" onClick={() => { setArticleDropDownShow2(false);  }}>
                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components-boutique">
                                {designerNameHeader}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="article-dropdown">
                                <FormControl className="globalSearch-deliveryOrder" as="input" placeholder="Name Designer..." value={designerFilterInput} onChange={handleDesignerFilter}></FormControl>
                                {
                                    designers.sort((a, b) => a.Name.localeCompare(b.Name)).filter(x => x.Name.toLowerCase().includes(designerFilterInput.toLowerCase()))
                                        .map(designer =>
                                            <Dropdown.Item variant="secondary" className="listGroup-item" active={false} onSelect={() => handleSetDesigner(designer)}>
                                                {designer.Name}
                                            </Dropdown.Item>
                                        )
                                    //designers.filter(x => articles.find(article => article.Articles.DesignerSysId === x.MandatorSysId) !== undefined).filter(x => x.Name.toLowerCase().includes(designerFilterInput.toLowerCase()))
                                    //    .sort((a, b) => a.Name.localeCompare(b.Name))
                                    //    .map(designer =>
                                    //        <Dropdown.Item variant="secondary" className="listGroup-item" active={false} onSelect={() => handleSetDesignerSelection(designer)}>
                                    //            {designer.Name}
                                    //        </Dropdown.Item>
                                    //    )
                                }
                                <LoadingSpinner task={taskName} area={"DeliveryOrderContainer"}/>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    {/*{!isFaexStorage ?*/}
                        <Col>
                            <FormCheck id="stock-check" className="check-wholeStock" type="checkbox" onClick={handleSetFetchWholeDesignerStock}
                            label="Kompletten Bestand des Designers auswählen" disabled={!isWholeStockAllowed} />
                        </Col>
                        {/*: null*/}
                    {/*}*/}
                </Row>
            </Form>

            

            <Form onSubmit={submitDeliveryOrder}>

                <Dropdown className="form" autoClose={true}>
                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components-articles" ref={node => articleDropdown = node} disabled={!isWholeStockAllowed}>
                        {articleNameHeader}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="article-dropdown">

                        <FormControl className="globalSearch-deliveryOrder" as="input" placeholder="Artikel..." value={articleFilterInput} onChange={handleArticleFilter}></FormControl>

                        <div className="dropdown-listGroup">
                            {articles.filter(x =>  /*&& x.SizeCat == sizeCat*/
                            (x.ArticleTypeName.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.ArticleNumberDesigner.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.ArticleIdFaex.toLowerCase().includes(articleFilterInput.toLowerCase())
                                || x.SalePrice.toString().includes(articleFilterInput.toLowerCase()) || x.ArticleIdFaex.toLowerCase().includes(articleFilterInput.toLowerCase())))
                                .sort((a, b) => a.ArticleTypeName.localeCompare(b.ArticleTypeName))
                                .map(article =>

                                    <ListGroup.Item className="dropdown-listGroup-item" value={article.ArticleTypeName} action onClick={(e) => handleChange(e, article)}>
                                        <Dropdown.Item variant="secondary" className="listGroup-item" active={false}>
                                            <Row >
                                                <Col className="dropdown-imageColumn">{RenderImage(article.Image)}</Col>
                                                <Col >{article.ArticleTypeName}</Col>
                                                <Col className="dropdown-article-smallField">{article.ArticleIdFaex}</Col>
                                                <Col >{article.ArticleNumberDesigner}</Col>
                                                <Col className="dropdown-article-smallField">{article.Colour}</Col>
                                                <Col className="dropdown-article-smallField">{article.SalePrice}€</Col>
                                                <OverlayTrigger trigger="hover" placement="top" overlay={DescriptionTooltip(article.DescriptionDesigner)}>
                                                    <Col className="dropdown-article-description">{article.DescriptionDesigner}</Col>
                                                </OverlayTrigger>
                                            </Row>
                                        </Dropdown.Item>
                                    </ListGroup.Item>
                                )
                            }
                        </div>

                        <Dropdown.Divider />
                        {/*<Dropdown.Item eventKey="0" >Neuer Artikeltyp</Dropdown.Item>*/}

                    </Dropdown.Menu>
                </Dropdown >
                <LoadingSpinner task={taskName} area={"DeliveryOrderContainerUpper"} />

                        {/* {sizeCats.map(sizeCat =>*/}
                                {/*<div>*/}
                                {/*    {articles.filter(x => x.Articles.DesignerSysId == designerSelection.OwnerMandatorSysId && x.SizeCat == sizeCat*/}
                                {/*        && (x.Articles.Name.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleNumberDesigner.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleIdFaex.toLowerCase().includes(articleFilterInput.toLowerCase())))*/}
                                {/*        .sort((a, b) => a.Articles.Name.localeCompare(b.Articles.Name))*/}
                                {/*        .map(article =>*/}
                                {/*        <Dropdown.Item variant="secondary" className="listGroup-item" active={false} onSelect={() => handleChange(article)}>*/}
                                {/*            */}{/*{article.Articles.Name}*/}
                                {/*            <Row>*/}
                                {/*                <Col xxl>{article.Articles.Name}</Col>*/}
                                {/*                <Col>{article.Articles.ArticleIdFaex}</Col>*/}
                                {/*                <Col>{article.Articles.ArticleNumberDesigner}</Col>*/}
                                {/*                <Col>{article.Articles.Colour}</Col>*/}
                                {/*                <Col>{article.Articles.SalePrice}</Col>*/}
                                {/*                */}{/*<Col>{article.Articles.ArticleTypeSysId}</Col>*/}
                                {/*            </Row>*/}
                                {/*        </Dropdown.Item>*/}
                                {/*    )}*/}
                                {/*</div>*/}
                            {/*)}*/}

                {articleNameHeader !== articleHeaderDefault && articleNameHeader !== articleHeaderDuringLoading ?
                    renderOrderInput() : <div className="placeholder">empty</div>
                }

                {uiError && renderErrorMessage()}

            </Form>

            <DeliveryOrderList removeOrderEntry={removeOrderEntry} deliveryOrders={deliveryOrder} articles={articles} remark={remark} resetOrderEntries={resetOrderEntries} isFaexDelivery={isFaexStorage} boutique={boutiqueSelection} handleCloseMask={handleCloseMask} reloadParent={reloadParent} isDraftUpdate={isDraftUpdate} draftSysId={draft !== null ? draft.TransactionSysId : null} transactionNumber={transactionNumber} transactionDate={transactionDate} isBackDelivery={backDelivery} designerStorageSysId={designerStorageSysId} />

            <Form className="remark-form">
                <Form.Group className="mb-3">
                    <Form.Label>Bemerkung zum Lieferschein</Form.Label>
                    <Form.Control as="textarea" defaultValue={draft !== null ? draft.Remark : template !== null ? template.Remark : ""} rows={3} onChange={(e) => setRemark(e.target.value)} />
                </Form.Group>
            </Form>

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            <LoadingSpinner task={taskName} area={"DeliveryOrderContainer"} />

        </div>
    )
}

const testing = (showSizes) => {
    console.log("StateSizes: " + showSizes)
    return showSizes;
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps)(DeliveryOrderContainer)

